module.exports = __webpack_public_path__ + "static/media/GovMB_Logo.1e79dea2.png";